import { wControl } from "$json/lib/control";
import { registerWidget } from "$json/lib/form-widgets";

(function ($, doc) {
  $(function () {
    $(doc).on("bb:preHandleData", function (event, data, status, req) {
      if (typeof data != "undefined" && data && data.groups)
        data.groups = $.map(data.groups, function (group) {
          group.controls = $.map(group.controls, function (control) {
            if (control.controltype == "grid") {
              if (control["font-class"] == "grid with links 2")
                control.controltype = "ntagrid";
            }
            return control;
          });
          return group;
        });
    });
  });

  /* A Collapsable Grid with Comment Fields
   *
   */
  var NtaGrid = {
    name: "ntagrid",
    tagName: "div",
    attribs: () => ({}),
    render: function (control, $widget, group) {
      $.each(control.value, function (i, row) {
        var $row = $('<div class="bb-collapsable bb-collapsed"></div>'),
          collapseid = "collapsible-" + control.id + "-" + i,
          $head = $(
            '<h3><button aria-controls="' +
              collapseid +
              '" aria-expanded="false" class="bb-uncollapsable bb-collapser"></button></h3>'
          ),
          $wrap = $(
            '<div id="' +
              collapseid +
              '" class="bb-collapsed-content" aria-hidden="true"></div>'
          ),
          $body = $("<table></table>");
        $wrap.get(0).style.display = "none";
        $widget.append($row);
        $row.append($head);
        $row.append($wrap);
        $wrap.append($body);

        $.each(row, function (ii, cell) {
          var $appender, $item;
          if (ii === 0) {
            $appender = $head.find("button");
          } else {
            if (ii === 1) {
              $item = $(
                '<tr><td rowspan="2" class="colname">Toelichting</td><td class="value"></td></tr>'
              );
            } else if (ii === 2) {
              $item = $('<tr><td class="value"></td></tr>');
            } else if (ii === 3) {
              $item = $(
                '<tr><td class="colname">Bron</td><td class="value"></td></tr>'
              );
            } else {
              $item = $(
                '<tr><td class="colname"></td><td class="value"></td></tr>'
              );
            }
            $body.append($item);
            $appender = $item.find(".value");
          }
          var column = control.columns[ii];
          wControl(
            $.extend(
              {},
              column,
              { id: control.id + "-" + i + "-" + ii },
              $.isPlainObject(cell) ? cell : { value: cell }
            ),
            group,
            $appender //append hereto
          );
        });
      });
      return $widget;
    }
  };

  registerWidget(NtaGrid);

  $(doc).on("bb:collapsing", ".bb-collapsable", function () {
    $(this).find(".bb-collapsed-content").slideToggle(500);
  });
})(jQuery, document);
